/**
 * Message handed to the Unify Coworker when someone refines a search from the
 * AI overview.
 *
 * @remarks
 * Change the wording here and nowhere else. `{{query}}` is replaced with what
 * the user searched for, and may sit anywhere in the sentence or appear more
 * than once. A template without the placeholder is sent as written, so the
 * search is dropped — keep it unless that is what you want.
 */
export const REFINE_WITH_COWORKER_PROMPT =
  'Help me refine this prompt: {{query}}';

/** Placeholder that {@link REFINE_WITH_COWORKER_PROMPT} fills with the search. */
const QUERY_PLACEHOLDER = '{{query}}';

/**
 * Builds the Coworker message that carries a search over for refining.
 *
 * @param query - What the user searched for.
 * @returns The prompt to send, with every placeholder replaced by `query`.
 *
 * @example
 * ```ts
 * buildRefineWithCoworkerPrompt('applications with high maturity');
 * // 'Help me refine this prompt: applications with high maturity'
 * ```
 */
export function buildRefineWithCoworkerPrompt(query: string): string {
  // A callback keeps dollar sequences in the query from being read as
  // replacement patterns.
  return REFINE_WITH_COWORKER_PROMPT.replaceAll(QUERY_PLACEHOLDER, () => query);
}
